import classes from './Card.module.css'


const Card = ({direction, children, extraClass}) => {
    return <div className={`${classes.item} ${classes[direction]} ${classes[extraClass]}`} >
        {children}
    </div>
}

export default Card